import { keyframes } from '@emotion/react';

/**
 * Soft ping-pong drift — eases to the end and back.
 * Avoids the hard 100%→0% jump that looks like flicker on looping gradients.
 */
export const gradientFlow = keyframes`
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
`;

export const gradientFlowReverse = keyframes`
  0% { background-position: 100% 50%; }
  50% { background-position: 0% 50%; }
  100% { background-position: 100% 50%; }
`;

const reducedMotion = {
  '@media (prefers-reduced-motion: reduce)': {
    animation: 'none !important',
    backgroundSize: '100% 100% !important',
  },
};

/** Primary CTA — gentle left↔right drift */
export function primaryGradientMotion(duration = '10s') {
  return {
    backgroundSize: '180% 100%',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '0% 50%',
    animation: `${gradientFlow} ${duration} ease-in-out infinite`,
    willChange: 'background-position',
    ...reducedMotion,
  };
}

/** Secondary CTA — opposite direction, slightly slower */
export function secondaryGradientMotion(duration = '12s') {
  return {
    backgroundSize: '180% 100%',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '100% 50%',
    animation: `${gradientFlowReverse} ${duration} ease-in-out infinite`,
    willChange: 'background-position',
    ...reducedMotion,
  };
}

/** Thin brand bars (header / palette card) */
export function brandBarMotion(duration = '14s') {
  return {
    backgroundSize: '160% 100%',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '0% 50%',
    animation: `${gradientFlow} ${duration} ease-in-out infinite`,
    willChange: 'background-position',
    ...reducedMotion,
  };
}
